import { createComponent } from '@mtfe/sweet';
import { common } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const toastBoxId = createUniqueId();
let toastBox = null;
let opacityTimerId = null;
let displayTimerId = null;

const Toast = props => {


    const { message, position = 'bottom', zIndex = 1000, time = 3000 } = props;

    let customStyle = position == 'center' ? 'top:48vh;' : (position == 'top' ? 'top:15vh;' : 'bottom:15vh;');
    customStyle += `z-index:${zIndex};`;

    const data = {
        toastBoxId,
        message: message || '提示',
        customStyle,
    }

    const events = {};

    if (!toastBox) {
        const component = createComponent(tpl, { data, style }, events);
        document.body.insertAdjacentHTML('afterbegin', component);
        toastBox = document.getElementById(toastBoxId);
    } else {
        toastBox.innerText = message;
        customStyle += `display:flex;opacity:1;`
        toastBox.style.cssText = customStyle;
    }

    opacityTimerId && clearTimeout(opacityTimerId);
    displayTimerId && clearTimeout(displayTimerId);

    opacityTimerId = setTimeout(() => {
        toastBox.style.opacity = 0
        displayTimerId = setTimeout(() => {
            toastBox.style.display = 'none'
        }, 500)
    }, time)
}

export default Toast